module.exports = __webpack_public_path__ + "img/icon_comment_1.0ce53a4a.png";